import Close from "@mui/icons-material/Close";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import TeamService from "../../service/TeamService";
import Modal from "../Modal";

import styles from "./InviteTeammateModal.module.scss";

const InviteTeammateModal = (props) => {
  const { open, onClose, teamId } = props;
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const [token, setToken] = useState({ value: null, teamId: null });
  useEffect(() => {
    const updateToken = async () => {
      if (!teamId) {
        //Can't get a token without the teamId
        return;
      }

      if (token.value && teamId === token.teamId) {
        // Token is up to date, do not update
        return;
      }
      const {
        data: { data: newToken },
      } = await TeamService.getInviteLink(teamId);

      setToken({ value: newToken, teamId });
    };

    updateToken();
  }, [open, teamId, token]);

  const link = `${process.env.REACT_APP_CLIENT_URL}/join/${token.value}`;

  const onCopy = () => {
    navigator.clipboard.writeText(link);
    setCopied(true);
  };

  return (
    <Modal show={open} className={styles.modal}>
      <Close
        className={styles.closeIcon}
        onClick={() => {
          setCopied(false);
          onClose();
        }}
      />
      <div className={styles.container}>
        <h4 className={styles.title}>{t("invite.invite_teammate")}</h4>
        <p>{t("invite.invite_description")}</p>
        <div className={styles.inviteDiv}>
          <input
            type="text"
            value={link}
            className={styles.input}
            readOnly
          ></input>
          <button className={styles.button} onClick={onCopy}>
            {copied ? t("invite.copied") : t("invite.copy")}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default InviteTeammateModal;
